import { render, staticRenderFns } from "./TransferInput.vue?vue&type=template&id=58c95068"
import script from "./TransferInput.vue?vue&type=script&lang=js"
export * from "./TransferInput.vue?vue&type=script&lang=js"
import style0 from "./TransferInput.vue?vue&type=style&index=0&id=58c95068&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports